import { createStore } from 'vuex'
import main from './main'
import auth from './auth'
import catalogue from './catalogue'
import cart from './cart'

const store = createStore({
  modules: {
    main,
    auth,
    catalogue,
    cart
  }
})

export function useStore() {
  return store
}

export default store
